module.exports = __webpack_public_path__ + "img/hr-tree-09-c-leaves.673f0a23.png";